import React, { useState, useEffect } from "react";
import FilterBar from "./FilterBar/FilterBar";
import ChartComponent from "./Charts/ChartComponent";
import NewsFeed from "./NewsFeed/NewsFeed";
import EmgptDiv from "./Emgpt/EmgptDiv";
import { useLocation } from "react-router-dom";
import {
  fetchDashboardData,
  updateChartData,
  getDefaultDates,
  initializeFilters,
  renderLoadingOrNoData,
} from "./DashboardUtils";
import { FetchDashboardDataRequest } from "./DashboardSerializer";
import {
  loadMoreNews,
  loadNews,
  loadNewsPointClick,
} from "./NewsFeed/NewsFeedUtils";
import { Helmet } from "react-helmet";

function ProductDashboard({ subTabs }) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const dashboard_name = params.get("dashboard_name");

  const { defaultStartDate, defaultEndDate } = getDefaultDates(
    subTabs,
    dashboard_name
  );

  const [filterDate, setFilterDate] = useState({
    endDate: defaultEndDate,
    startDate: defaultStartDate,
  });
  const [filters, setFilters] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);
  const [dashboardChartData, setDashboardChartData] = useState(null);
  const [newsList, setNewsList] = useState([]);
  const [isNewsLoading, setIsNewsLoading] = useState(false);
  const [isMoreNewsLoading, setIsMoreNewsLoading] = useState(false);
  const [noMoreNews, setNoMoreNews] = useState(false);
  const [documentIds, setDocumentIds] = useState([]);
  const [offset, SetOffset] = useState(0);
  const [selectedFilters, setSelectedFilters] = useState({
    filter1: null,
    filter2: "",
    filter3: [""],
  });

  useEffect(() => {
    initializeFilters(
      setDashboardData,
      setFilters,
      setDashboardChartData,
      setNewsList,
      setDocumentIds,
      SetOffset
    );

    fetchDashboardData({
      fetchDashboardDataRequest: new FetchDashboardDataRequest(
        dashboard_name,
        filterDate
      ),
      setFilters,
      setSelectedFilters,
      selectedFilters,
      setDashboardData,
      setIsLoading,
    });
  }, [filterDate]);

  useEffect(() => {
    const { defaultStartDate, defaultEndDate } = getDefaultDates(
      subTabs,
      dashboard_name
    );
    setSelectedFilters({ filter1: null, filter2: "", filter3: [""] });
    setFilterDate({ endDate: defaultEndDate, startDate: defaultStartDate });
  }, [dashboard_name]);

  useEffect(() => {
    if (dashboardData) {
      updateChartData({
        dashboardData,
        selectedFilters,
        setDashboardChartData,
        filterDate,
      });
    }
  }, [selectedFilters, filters]);

  useEffect(() => {
    if (dashboardChartData) {
      loadNews(
        dashboardChartData,
        setNewsList,
        setIsNewsLoading,
        filterDate,
        setDocumentIds,
        SetOffset,
        setNoMoreNews
      );
    }
  }, [dashboardChartData]);

  const handleLoadMoreNews = () => {
    loadMoreNews({
      dashboardChartData,
      offset,
      setIsMoreNewsLoading,
      setNewsList,
      SetOffset,
      filterDate,
      setNoMoreNews,
      setDocumentIds,
      documentIds,
      newsList
    });
  };

  const handlePointClick = (data) => {
    loadNewsPointClick(
      [data.options.isin],
      setNewsList,
      setIsNewsLoading,
      data.category,
      setDocumentIds,
      setNoMoreNews
    );
  };

  const dashboardName = subTabs
    .filter((x) => x.dashboardName === dashboard_name)
    .map((x) => x.name);

  return (
    <>
      <Helmet>
        <title>Dashboard | EMAlpha</title>
      </Helmet>
      <div className="container-fluid p-2 w-100 h-100">
        <FilterBar
          filters={filters}
          filterDate={filterDate}
          setFilterDate={setFilterDate}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          isLoading={isLoading}
          dashboardChartData={dashboardChartData}
        />
        <div
          className="p-3 bg-white rounded-4 rounded-left w-100"
          style={{ height: "94%" }}
        >
          {renderLoadingOrNoData(
            isLoading,
            dashboardChartData,
            dashboardName[0]
          ) || (
            <>
              <div className="text-dark-gray" style={{ height: "5%" }}>
                <h5 className="p-1 h3">{dashboardName[0] || "Dashboard"}</h5>
              </div>
              <div
                className="w-100 rounded-3 border-3 shadow"
                style={{ overflow: "auto", height: "30%" }}
              >
                <ChartComponent
                  dashboardName={dashboard_name}
                  dashboardChartData={dashboardChartData}
                  legends={true}
                  handlePointClick={handlePointClick}
                />
              </div>
              <div className="d-flex flex-col w-100" style={{ height: "65%" }}>
                <div className="w-50">
                  <NewsFeed
                    newsList={newsList}
                    isNewsLoading={isNewsLoading}
                    noMoreNews={noMoreNews}
                    setDocumentIds={setDocumentIds}
                    documentIds={documentIds}
                    handleLoadMoreNews={handleLoadMoreNews}
                    isMoreNewsLoading={isMoreNewsLoading}
                  />
                </div>
                <div className="w-50 h-100">
                  <EmgptDiv documentIds={documentIds} />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default ProductDashboard;
